<template>
  <Dialog title="Edit Announcement" :show="isOpen" :onClose="onClose">
    <el-form :model="item" label-width="120px" label-position="left" size="small">
      <el-form-item label="Title" required>
        <el-input v-model="item.title" />
      </el-form-item>
      <el-form-item label="Tag" required>
        <el-input v-model="item.tag" />
      </el-form-item>
      <el-form-item label="Content" required>
        <el-input v-model="item.content" type="textarea" />
      </el-form-item>
      <el-form-item label="Image">
        <img v-if="item.image_url" :src="item.image_url" height="100px" width="auto" />
        <el-input v-model="item.image_url" readonly />
        <el-upload :on-success="onUploadSuccess" :data="data" :headers="headers" accept="image/*" :action="action" :file-list="fileList">
          <el-button size="mini" type="primary">Upload</el-button>
        </el-upload>
        <el-button @click="removeImage" v-if="item.image_url" size="mini" type="default">Remove</el-button>
      </el-form-item>
      <el-form-item label="CTA">
        <el-input v-model="item.cta" />
      </el-form-item>
      <el-form-item label="CTA Url">
        <el-input v-model="item.cta_url" />
      </el-form-item>
      <el-form-item label="Publish?">
        <el-checkbox v-model="item.is_published_as_draft">Publish as draft for admins</el-checkbox>
        <el-checkbox v-model="item.is_published">Publish announcement</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">Save</el-button>
        <el-button @click="onClose()">Cancel</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog';
import { pick } from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      fileList: [],
      data: null
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    isOpen: Boolean,
    onClose: Function,
  },
  components: {
    Dialog,
  },
  computed: {
    ...mapGetters(['token']),
    headers() {
      return { 'Authorization': 'JWT ' + this.token };
    },
    action() {
      const baseUrl = 'https://api.animaapp.com';
      return `${baseUrl}/v2/uploads/announcements/${this.item.id}/image_url`;
    }
  },
  methods: {
    ...mapActions(['getAnnouncements']),
    onUploadSuccess(response) {
      this.fileList = [];
      this.item.image_url = response.public_url;
    },
    async save() {
      try {
        const payload = pick(this.item, ['title', 'content', 'tag', 'cta', 'cta_url', 'is_published', 'is_published_as_draft']);
        await this.$api.put(`/product/announcements/${this.item.id}`, payload);
        this.$message.success('Saved successfully');
        this.getAnnouncements();
        this.onClose();
      } catch (err) {
        this.$notify.error({
          title: 'Failed saving announcement',
          message: err.message
        });
      }
    },
    async removeImage() {
      try {
        const payload = { image_url: null };
        await this.$api.put(`/product/announcements/${this.item.id}`, payload);
        this.item.image_url = null;
        this.$message.info('Removed image successfully');
      } catch (err) {
        this.$notify.error({
          title: 'Failed removing image',
          message: err.message
        });
      }
    }
  },
  watch: {
    'item.is_published_as_draft'(value) {
      if (value) {
        this.item.is_published = false;
      }
    },
    'item.is_published'(value) {
      if (value) {
        this.item.is_published_as_draft = false;
      }
    }
  }
}
</script>